import React, { useState, createContext, useContext } from 'react';
export type MaterialType = 'Permanent' | 'Removable' | 'Holographic' | 'Chrome';
export type LaminationType = 'Matte' | 'Gloss';
export type CutlineType = 'Cut to Outline' | 'Basic Shape' | 'No Cutline';
export type UploadState = 'empty' | 'loading' | 'loaded';
export interface UploadedFile {
  name: string;
  size: string;
  thumbnail?: string;
}
interface StickerContextType {
  // Configuration
  quantity: number;
  setQuantity: (q: number) => void;
  size: string;
  setSize: (s: string) => void;
  customWidth: number;
  setCustomWidth: (w: number) => void;
  customHeight: number;
  setCustomHeight: (h: number) => void;
  material: MaterialType;
  setMaterial: (m: MaterialType) => void;
  lamination: LaminationType;
  setLamination: (l: LaminationType) => void;
  cutline: CutlineType;
  setCutline: (c: CutlineType) => void;
  // Upload
  uploadedFile: UploadedFile | null;
  setUploadedFile: (f: UploadedFile | null) => void;
  uploadState: UploadState;
  setUploadState: (s: UploadState) => void;
  // Pricing
  totalPrice: number;
  pricePerSticker: number;
}
const StickerContext = createContext<StickerContextType | undefined>(undefined);
export function StickerProvider({
  children
}: {
  children: ReactNode;
}) {
  const [quantity, setQuantity] = useState(350);
  const [size, setSize] = useState('2 x 2 inch');
  const [customWidth, setCustomWidth] = useState(2);
  const [customHeight, setCustomHeight] = useState(2);
  const [material, setMaterial] = useState<MaterialType>('Permanent');
  const [lamination, setLamination] = useState<LaminationType>('Matte');
  const [cutline, setCutline] = useState<CutlineType>('Cut to Outline');
  const [uploadedFile, setUploadedFile] = useState<UploadedFile | null>(null);
  const [uploadState, setUploadState] = useState<UploadState>('empty');
  // Mock pricing logic
  const pricePerSticker = 3.89;
  const totalPrice = quantity * pricePerSticker;
  return <StickerContext.Provider value={{
    quantity,
    setQuantity,
    size,
    setSize,
    customWidth,
    setCustomWidth,
    customHeight,
    setCustomHeight,
    material,
    setMaterial,
    lamination,
    setLamination,
    cutline,
    setCutline,
    uploadedFile,
    setUploadedFile,
    uploadState,
    setUploadState,
    totalPrice,
    pricePerSticker
  }} data-id="element-284">
      {children}
    </StickerContext.Provider>;
}
export function useSticker() {
  const context = useContext(StickerContext);
  if (context === undefined) {
    throw new Error('useSticker must be used within a StickerProvider');
  }
  return context;
}